/** Max concurrent live chart preview runtimes (each has full provider stack). */
export const MAX_LIVE_CHART_PREVIEWS = 4;

/**
 * Keep the most recent charts warm, but leave headroom for viewport-activated
 * older messages to become live when users scroll back in transcript history.
 * This count must stay below `MAX_LIVE_CHART_PREVIEWS` so `pickLiveChartPreviewMessageIds`
 * can still add viewport-visible older messages after the recent slice is added.
 */
export const ALWAYS_LIVE_RECENT_SINGLE_CHART_COUNT = 2;

/**
 * Choose which transcript `single_chart` message ids should mount a ChartRuntimeShell.
 * `singleChartMessageIdsOrdered` must be oldest-first. `viewportVisibleIds` is the set of
 * message ids whose slot intersects the transcript scroll container.
 */
export function pickLiveChartPreviewMessageIds(
  singleChartMessageIdsOrdered: readonly string[],
  viewportVisibleIds: ReadonlySet<string>
): string[] {
  const result: string[] = [];
  const add = (id: string) => {
    if (result.includes(id)) {
      return;
    }
    if (result.length >= MAX_LIVE_CHART_PREVIEWS) {
      return;
    }
    result.push(id);
  };

  /**
   * Prefer slots the user can see (viewport) so map/data previews mount while
   * scrolling history. Then keep a few recent charts warm when scrolled away.
   */
  const newestFirst = [...singleChartMessageIdsOrdered].reverse();
  newestFirst.forEach((id) => {
    if (viewportVisibleIds.has(id)) {
      add(id);
    }
  });
  const recentAlways = singleChartMessageIdsOrdered.slice(
    -ALWAYS_LIVE_RECENT_SINGLE_CHART_COUNT
  );
  recentAlways.forEach((id) => {
    add(id);
  });

  return result;
}
